import { render, staticRenderFns } from "./UserRegistrationSummaryDetails.vue?vue&type=template&id=744f6da5&"
import script from "./UserRegistrationSummaryDetails.vue?vue&type=script&lang=js&"
export * from "./UserRegistrationSummaryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports